// Common
import { Pipe, PipeTransform } from '@angular/core';
import { assertExhaustive } from '@modules/common/utils/switch';

// Types
import { SHEETS_STRINGS } from '@sharedlib/sheets-editor/sheets.strings';
import { VirtualFolder } from '../types/virtual-folder';

@Pipe({
  name: 'titleBySheetsFilter',
  standalone: false,
})
export class TitleBySheetsFilterPipe implements PipeTransform {
  transform(value: VirtualFolder, containerName?: string | null): string {
    if (!value) {
      return containerName || 'All';
    }

    switch (value) {
      case 'search_results':
        return 'All Results';
      case 'all_sheets':
        return SHEETS_STRINGS.Workbooks;
      case 'recent':
        return 'Recent';
      case 'flagged':
        return 'Flagged';
      case 'followed':
        return 'Follow Up';
      case 'archived':
        return 'Archive';
      case 'deleted':
        return 'Trash';
      case 'all_sheetFolders':
        return 'Folders';
      case 'snoozed':
        return 'Snoozed';
      case 'templates':
        return SHEETS_STRINGS['Templates'];
      default:
        return assertExhaustive(value);
    }
  }
}
